import { useMemo } from "react";
import clsx from "clsx";
import initialism from "initialism";
import randomColor from "randomcolor";
import styles from "./Avatar.module.css";

type Props = {
  name?: string;
  className?: string;
  image?: string;
  size?: "sm" | "md";
};

const Avatar = ({
  name,
  className,
  image,
  size
}: Props) => {
  const acronym = useMemo(() => initialism(name, 2), [name]);
  const avatarStyle = useMemo(() => ({
    backgroundColor: image ? "var(--alias-color-background-base)" : randomColor({
      // "seed" used to persist color for same value
      seed: name ?? "",
      luminosity: "dark"
    })
  }), [name, image]);
  const avatarSize = size ? styles[size] : "";

  return (
    <div className={clsx(styles.avatar, className, avatarSize)} style={avatarStyle} aria-hidden>
      {
        image ? (
          <img src={image} alt={`${name} avatar`} />
        ) : (
          <span className={styles.avatarText}>{acronym}</span>
        )
      }
    </div>
  );
};

export default Avatar;
